module.exports = __webpack_public_path__ + "img/bg.78c57a5d.jpg";